import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import axiosInstance from "../../axiosInterceptor";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { submitForm } from "../../utils/apiUtils";
import { Button } from "reactstrap";

const EmailConfiguration = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [btnloading,setBtnLoading]=useState(false)
  const [data, setData] = useState({
    email: "",
    password: "",
    host: "",
    port: "",
    toEmail: "",
    bccEmail: "",
    ccEmail: "",
  });

  const fetchData = async () => {
    try {
      const response = await axiosInstance.get(`emailsetting`);
      const { data } = response.data;
      const newData = data[0];
      if (newData.id) {
        delete newData.id;
        delete newData.createdAt;
        delete newData.updatedAt;
        delete newData.__v;
      }
      setData(newData);
    } catch (error) {
      toast.error(
        error.response?.data?.message
          ? error.response?.data?.message
          : "Something went wrong. Please try again!!"
      );
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleUpdate = async (e) => {
    setBtnLoading(true)
    try{
      e.preventDefault();
      await submitForm({
        data,
        url: "emailsetting",
      });
    }catch(error){
      return error
    }finally{
      setBtnLoading(false)
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="content-wrapper">
      <div className="page-header mt-5 mx-4">
        <h3 className="page-title">Email Configuration</h3>
      </div>
      <div className="col-md-12 grid-margin stretch-card">
        <div className="col-md-12">
          <div className="card">
            <div className="card-body">
              <form className="pt-3" onSubmit={handleUpdate}>
                <div className="page-header mb-2">
                  <h2 className="page-title">Sender </h2>
                </div>
                <div className="row">
                  <div className="col-sm-4">
                    <div className="form-group">
                      <label
                        htmlFor="exampleInputUsername2"
                        className="col-form-label "
                      >
                        Email
                      </label>
                      <input
                        type="email"
                        className="form-control form-control-sm  border border-dark  "
                        id="email"
                        name="email"
                        placeholder="Enter email"
                        value={data?.email}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="col-sm-4">
                    <div className="form-group">
                      <label
                        htmlFor="password"
                        className="col-form-label "
                      >
                        App Password
                      </label>
                      <div className="input-group">
                        <input
                          type={showPassword ? "text" : "password"}
                          className="form-control form-control-sm border border-dark  "
                          id="password"
                          name="password"
                          placeholder="Enter password"
                          value={data?.password}
                          onChange={handleChange}
                        />
                        <div className="input-group-append">
                          <span
                            className="input-group-text "
                            onClick={togglePasswordVisibility}
                            style={{
                              cursor: "pointer",
                            }}
                          >
                            <h5 className="mt-2">
                              {showPassword ? (
                                <FaEye className=" text-dark" />
                              ) : (
                                <FaEyeSlash className=" text-dark" />
                              )}
                            </h5>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-2">
                    <div className="form-group">
                      <label
                        htmlFor="exampleInputUsername2"
                        className="col-form-label "
                      >
                        SMTP Host
                      </label>
                      <input
                        type="text"
                        className="form-control form-control-sm border border-dark  "
                        id="host"
                        name="host"
                        placeholder="Enter host"
                        value={data?.host}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="col-sm-2">
                    <div className="form-group">
                      <label
                        htmlFor="exampleInputUsername2"
                        className="col-form-label "
                      >
                        Port
                      </label>
                      <input
                        type="number"
                        className="form-control form-control-sm border border-dark  "
                        id="port"
                        name="port"
                        placeholder="Enter port"
                        value={data?.port}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                </div>
                <div className="page-header mt-4 mb-2">
                  <h2 className="page-title">Receivers </h2>
                </div>
                <div className="row">
                  {/* <div className="col-sm-4">
                    <div className="form-group">
                      <label
                        htmlFor="exampleInputUsername2"
                        className="col-form-label "
                      >
                        To Email (Enquiry)
                      </label>
                      <input
                        type="email"
                        className="form-control form-control-sm"
                        id="toEmail"
                        name="toEmail"
                        placeholder="Enter to email"
                        value={data?.toEmail}
                        onChange={handleChange}
                      />
                    </div>
                  </div> */}
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label
                        htmlFor="exampleInputUsername2"
                        className="col-form-label "
                      >
                        BCC Email
                      </label>
                      <input
                        type="email"
                        className="form-control form-control-sm border border-dark  "
                        id="bccEmail"
                        name="bccEmail"
                        placeholder="Enter bcc email"
                        value={data?.bccEmail}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label
                        htmlFor="exampleInputUsername2"
                        className="col-form-label "
                      >
                        CC Email
                      </label>
                      <input
                        type="email"
                        className="form-control form-control-sm border border-dark  "
                        id="ccEmail"
                        name="ccEmail"
                        placeholder="Enter cc email"
                        value={data?.ccEmail}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                </div>

                <div className="text-center mt-4">
                   <Button type="submit" color="primary" disabled={btnloading}>
                             {btnloading ? (
                               <>
                                 <span
                                   className="spinner-border spinner-border-sm me-2"
                                   role="status"
                                   aria-hidden="true"
                                 ></span>
                                 Saving...
                               </>
                             ) :   (
                               "Save"
                             )}
                           </Button>
                  <Link to="/dashboard">
                    <Button color="danger" className="ml-3">Cancel</Button>
                  </Link>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmailConfiguration;
